<script setup lang="ts">
  import { FlowDestinationWidget } from '@/widgets/Flow'
  import { useApiRequestsAbort } from '@/shared/composables'

  useApiRequestsAbort()
</script>

<template>
  <FlowDestinationWidget />
</template>
